import { Button, Drawer, Input } from 'antd';
import getFormatMessage from '../../../../../locales/get-format-message';
import closeIcon from '../../../../../assets/svg/close-icon.svg';
import { useState } from 'react';
import { putDrawMoney } from '../../../../../api';
import { messageError } from '../../../../../components/message';
import { useSelector } from 'react-redux';
import { IRootState } from '../../../../../store/reducers';

interface IProps {
  readonly onClose: (status?: boolean) => void;
  // readonly row?: any;
  readonly currentMoney: string | undefined;
  readonly studioId: string;
  readonly companyName: string | undefined;
}

export const WithdrawalDrawer = (props: IProps) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [isAmountExceeded, setIsAmountExceeded] = useState<boolean>(false);
  const [isAmountDisabled, setIsAmountDisabled] = useState<boolean>(false);
  const [inputValue, setInputValue] = useState<string>('');
  const [disabled, setDisabled] = useState<boolean>(true);
  const userInfo = useSelector((state: IRootState) => state.common.userInfo);
  const userID = userInfo?.UserID || '';

  const handleInputChange = (e: { target: { value: string } }) => {
    const amount = e.target.value;
    const regex = /^[0-9]*\.?[0-9]{0,2}$/; // 允许输入数字和最多两位小数
    if (regex.test(amount)) {
      setInputValue(amount);
      const parsedAmount = parseFloat(amount);
      if (amount === '') {
        setDisabled(true); // 输入为空时禁用按钮
      } else if (parsedAmount < 0.01) {
        console.log('parsedAmount', isAmountExceeded);
        setIsAmountDisabled(true);
        setDisabled(true);
      } else if (parsedAmount > Number(props.currentMoney)) {
        setIsAmountExceeded(true);
        setDisabled(true);
      } else {
        setIsAmountDisabled(false);
        setIsAmountExceeded(false);
        setDisabled(false);
      }
    } else {
      setDisabled(true);
    }
  };

  const handleSubmit = async () => {
    if (inputValue === '0') {
      messageError(getFormatMessage('amount_not_zero'));
      return;
    }
    if (props.currentMoney) {
      if (parseFloat(inputValue) > parseFloat(props.currentMoney)) {
        return;
      }
      setLoading(true);
      const res = await putDrawMoney(props.studioId, inputValue, userID);
      if (res) {
        props.onClose(true);
      } else {
        messageError(getFormatMessage('failed_submit'));
      }
      setLoading(false);
    } else {
      messageError(getFormatMessage('failed_submit'));
    }
  };
  const handleOpenCancel = () => {
    props.onClose();
  };

  return (
    <Drawer
      onClose={() => props.onClose()}
      title={
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <span>{getFormatMessage('withdrawal')}</span>
          <img
            src={closeIcon}
            className="sync-close-icon"
            onClick={() => props.onClose()}
          />
        </div>
      }
      placement="right"
      width={720}
      closable={false}
      visible={true}
      headerStyle={{
        position: 'sticky',
        top: 0,
        zIndex: 1,
        marginLeft: '3px',
      }}
      footer={
        <div
          style={{
            textAlign: 'left',
          }}
        >
          <button className="gc-btn sub-button" onClick={handleOpenCancel}>
            {getFormatMessage('close')}
          </button>
          <Button
            className="gc-btn gc-btn-primary gc-btn-download"
            loading={loading}
            onClick={handleSubmit}
            disabled={disabled || loading}
          >
            {getFormatMessage('submit')}
          </Button>
        </div>
      }
    >
      <div className="re-report">
        <div className="edit-title">
          {getFormatMessage('withdrawal_money')}
          <span className="require-icon">*</span>
        </div>
        <div className="money-input">
          <span className="money-icon">¥</span>
          <Input
            className={`drawl-money-input ${
              isAmountExceeded || isAmountDisabled ? 'exceeded-input' : ''
            }`}
            width={175}
            // addonBefore={<span className="money-icon">¥</span>}
            placeholder={getFormatMessage('enter_money')}
            value={inputValue}
            onChange={handleInputChange}
          />
        </div>
        <div
          className={`drawl-money-desc ${isAmountExceeded ? 'exceeded' : ''}`}
        >
          {/* 余额输入过大判断-样式 drawl-money-warn-desc*/}
          {getFormatMessage('withdrawal_money_not_over')}
          <span className="money-yellow">
            ¥{(Number(props.currentMoney) || 0).toFixed(2)}
          </span>
        </div>

        <div className="drawl-content">
          <div className="drawl-account">
            {getFormatMessage('account_received')}
          </div>
          <div className="drawl-account-name">
            {/* 企业认证的公司名称 */}
            {props.companyName}
            <span className="drawl-account-desc">
              {getFormatMessage('come_back_to_payment_channel')}
            </span>
          </div>
        </div>
      </div>
    </Drawer>
  );
};
